import React from 'react';
import classNames from 'classnames';
import TellyChair from '../../images/telly-chair.svg';

interface ComingSoonProps {
	body?: string;
	title?: string;
	className?: string;
	tellyImage?: string;
}

export default function ComingSoon(props: ComingSoonProps) {
	const {
		body,
		title = 'Coming Soon',
		className = '',
		tellyImage = TellyChair,
	} = props;

	return (
		<div className={classNames('coming-soon', className)}>
			<div className="coming-soon-image">
				<div className="coming-soon-gradient" />
				<img
					src={tellyImage}
					alt="Telly sitting in a film production chair"
				/>
			</div>
			<h4 className="coming-soon-title bl-font-header">{title}</h4>
			{body && (
				<div className="coming-soon-text bl-font-p2">{body}</div>
			)}
		</div>
	);
}
